module.exports = __webpack_public_path__ + "static/media/architecture.654b359c.jpg";